import { render, staticRenderFns } from "./Invites.vue?vue&type=template&id=8c3d7ac4"
import script from "./Invites.vue?vue&type=script&lang=ts"
export * from "./Invites.vue?vue&type=script&lang=ts"
import style0 from "./Invites.vue?vue&type=style&index=0&id=8c3d7ac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports